module.exports = __webpack_public_path__ + "img/3.fc7b809.jpg";